/**
 * Converts any value to a boolean.
 *
 * @param value
 */
export function toBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value === 'string') {
    return value.toUpperCase() === 'TRUE' || value === '1'
  }

  if (typeof value === 'number') {
    return value !== 0
  }

  return !!value
}
